import React from "react";
import { Button, Select, Input } from "../../components";

const STATUS = [
  {
    label: "Suspendidos",
    value: 2
  },
  {
    label: "Activos",
    value: 1
  }
];
class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        status: "",
        search: "",
      },
      searchTimeout: null,
    };
  }

  componentWillUnmount() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if (isText) {
      const searchTimeout = setTimeout(() => {
        this.props.submitted(this.state.form);
      }, 700);
      this.setState({ searchTimeout });
    } else {
      this.props.submitted(this.state.form);
    }
  };

  handleChange = (emitter, string) => {
    let { name, value, type } = emitter.target;
    const isText = !['select-one', 'select-multiple', 'checkbox', 'radio'].includes(type);

    this.setState(state => ({
      form: {
        ...state.form,
        [name]: value
      }
    }), () => {
      this.autoFilter(isText);
    });
  };
  
  render() {
    const { form } = this.state;

    return (
      <form
        onSubmit={emitter => {
          emitter.preventDefault();
          this.props.submitted(form);
        }}
      >
        <div className="row">
          <div className="col-md-6">
            <Input
              color="white"
              name="search"
              label="Búsqueda"
              onChange={emitter => this.handleChange(emitter, null)}
              value={form.search}
              placeholder="Buscar por Nombre"
            />
          </div>
          <div className="col-md-6">
            <Select
              color="white"
              name="status"
              label="Estatus"
              style={{ textTransform: "capitalize" }}
              defaultname="Todos"
              defaultvalue=""
              disabledFirst="false"
              onChange={emitter => this.handleChange(emitter, null)}
              value={form.status}
              options={STATUS}
            />
          </div>
        </div>
      </form>
    );
  }
}

export default Filter;
